import React from 'react'
import {InfoTooltipTrigger, PanelFooter} from '../../../shared';
import {Button} from '../../../ui-components';
import {ActionsPopovers, ActionsTooltip, BrigadeInfo, DiagnoseInfo, HospitalInfo, PatientInfo} from "../components";
import {useAppDispatch, useAppSelector} from "../../../core/hooks";
import {
  changeCustomerErCallStatus,
  changeErCallStatus,
  customerEndErCallFromHospitalizationFrom,
  endErCallFromHospitalizationFrom
} from '../../requests/er-thunk'
import { ER_CALL_STATUSES } from '../../../services/constants'
import CustomerDpInfo from "../../sentry/CustomerDpInfo";
import DpEmergencyPatientInfo from "../DpEmergencyComponents/DpEmergencyPatientInfo"
import PayInfoDp from "../../sentry/DpComponents/PayInfoDp";

const BookingApprovedRequest = () => {
  const dispatch = useAppDispatch()
  const {request, pool, er_call, payment} = useAppSelector(state => state.requests)

  return (
    <div id='closed-request' className='request-info-container pb-80'>
      <PayInfoDp/>
      <HospitalInfo/>
      <DiagnoseInfo/>
      <BrigadeInfo/>
      {request && request.type ===3 && <CustomerDpInfo/>}
      <DpEmergencyPatientInfo br={request}/>
      {/*<PatientInfo/>*/}
      {er_call.status !==27 &&<PanelFooter className='d-flex flex-space-around'>
        <Button disabled={payment.type ===1 && (payment.status === 8 ||payment.status === 9)} type='contained' onClick={() => dispatch(changeCustomerErCallStatus(10))}>Начать Госпитализацию</Button>
        <Button type='outlined'
                onClick={() => dispatch(customerEndErCallFromHospitalizationFrom(ER_CALL_STATUSES.endedLeftInPlace))}>На
          месте</Button>
        <Button type='outlined'
                onClick={() => dispatch(customerEndErCallFromHospitalizationFrom(ER_CALL_STATUSES.endedRefusedHospital))}>Отказ
          от Гсп.</Button>
        <InfoTooltipTrigger dataFor={'actions-menu'} className='ml-15'/>
      </PanelFooter>}
      {er_call.status ===27 &&<PanelFooter className='d-flex flex-space-around'>
          <Button type='outlined' className={'width-40'} onClick={() => dispatch(customerEndErCallFromHospitalizationFrom(ER_CALL_STATUSES.endedLeftInPlace))} >На месте</Button>
          <Button type='outlined' className={'width-40'} onClick={() => dispatch(customerEndErCallFromHospitalizationFrom(ER_CALL_STATUSES.endedRefusedHospital))}>Отказ от Гсп.</Button>
      </PanelFooter>}
      <ActionsTooltip id='actions-menu' offsetLeft={150} offsetTop={-20}/>
      <ActionsPopovers/>
    </div>
  )
}

export default BookingApprovedRequest
